import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getCurrentWeek } from "../../store/slices/time";
import Util from "../../util/util";
import useLeagueSeason from "./useLeagueSeason";

export default function useWeek() {
  const { leagueSeason } = useLeagueSeason();
  const { week: weekUrl } = useParams();
  const currentWeek = useSelector(getCurrentWeek);

  let seasonStartWeek = null,
    playoffsStartWeek = null,
    numPlayoffTeams = null,
    numPlayoffWeeks = null,
    totalNumWeeks = null;

  /** @type {?number} selectedWeek */
  let selectedWeek = null;

  if (weekUrl) {
    selectedWeek = Util.weekFromUrl(weekUrl);
  }

  const loaded = !!leagueSeason;

  if (loaded) {
    if (
      selectedWeek &&
      !Util.isValidWeek(selectedWeek, leagueSeason.obj.season)
    ) {
      console.error(`invalid week: ${selectedWeek}`);
      selectedWeek = null;
    }

    ({ seasonStartWeek, playoffsStartWeek, numPlayoffTeams } =
      leagueSeason.obj.settingsLeague);
    numPlayoffWeeks = Math.ceil(Math.log2(numPlayoffTeams));

    const { season } = leagueSeason.obj;
    totalNumWeeks = Util.getNumWeeksInNflSeason(season);
  }

  if (!selectedWeek) selectedWeek = currentWeek;
  let selectedWeekUrl = Util.weekToUrl(selectedWeek);

  return {
    currentWeek,
    selectedWeek,
    selectedWeekUrl,
    seasonStartWeek,
    playoffsStartWeek,
    numPlayoffWeeks,
    totalNumWeeks,
  };
}
